import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { Grid } from '@material-ui/core';
import { translate } from 'helpers/intl';
import messages from 'containers/AutoDetailsPage/messages';
import { AssuranceIcon } from 'images';
import { sanlamVeryDarkBlue } from 'Material-UI/colors';
import {
  StyledCaptions,
  ItemWrapper,
  SizedSmallSectionHeader,
  SizedGridItem,
} from 'containers/EpargnDetailsPage/FilesEpargn/styles';
import _, { get } from 'lodash';
import { getAttestationEpargn } from 'utils/string';
import GaClickHOC from 'helpers/GATracking/GaClickHOC';
import GATracking, { EVENT_CATEGORIES, EVENT_ACTION } from 'helpers/GATracking';

const FilesEpargn = (props: {
  intl: IntlShape;
  isAttestation?: boolean;
  numPolice: string;
  codeProduit: string;
  numAdhesion: string;
  matricule: string;
  ppr: string;
  files: {
    uri: any;
    category: string;
  }[];
}) => {
  const token = localStorage.getItem('token');
  return (
    <>
      {props.files ? (
        <>
          <Grid container spacing={3}>
            <Grid xs={12} item>
              <SizedSmallSectionHeader color={sanlamVeryDarkBlue} weight="bold">
                {translate({ ...messages.DownloadFileTitle }, props)}
              </SizedSmallSectionHeader>
            </Grid>
            {props.files.map((item: any, index) =>
              !_.isEmpty(item.uri) ? (
                <SizedGridItem item key={index}>
                  <ItemWrapper
                    data-testid={`download-file-${index}`}
                    onClick={() => global.open(item.uri)}
                  >
                    <img
                      alt="downloadIcon"
                      src={AssuranceIcon['downloadIcon']}
                    />
                    <StyledCaptions>
                      {translate(get(messages, item.category), props)}
                    </StyledCaptions>
                  </ItemWrapper>
                </SizedGridItem>
              ) : (
                <></>
              ),
            )}
            {props.isAttestation ? (
              <SizedGridItem item>
                <GaClickHOC
                  category={EVENT_CATEGORIES.EPARGN_DETAILS}
                  label="Tab 2: Mes contrats_Attestation d'épargne"
                >
                  <ItemWrapper
                    data-testid={`download-file-AttestationEpargn`}
                    onClick={() => {
                      global.open(
                        getAttestationEpargn(
                          props.codeProduit,
                          props.numPolice,
                          props.numAdhesion,
                          props.matricule,
                          props.ppr,
                          token,
                        ),
                      );
                      GATracking.event(
                        EVENT_CATEGORIES.EPARGN_DETAILS,
                        EVENT_ACTION.LOAD,
                        "Tab 2: Mes contrats_Attestation d'épargne",
                      );
                    }}
                  >
                    <img
                      alt="downloadIcon"
                      src={AssuranceIcon['downloadIcon']}
                    />
                    <StyledCaptions>
                      {translate(get(messages, 'attestion_epargn'), props)}
                    </StyledCaptions>
                  </ItemWrapper>
                </GaClickHOC>
              </SizedGridItem>
            ) : (
              <></>
            )}
          </Grid>
        </>
      ) : (
        <></>
      )}
    </>
  );
};
export default injectIntl(FilesEpargn);
